module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transctl"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('tradeMng.crumbs.L1')))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('tradeMng.crumbs.L4')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel down"
  }, [_c('div', {
    staticClass: "panel-header panel-header__auto"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules
    }
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.panel.time')))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "dateRangeValue"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "editable": false,
      "placeholder": _vm.$t('tradeMng.panel.range'),
      "size": "small",
      "clearable": false
    },
    model: {
      value: (_vm.form.dateRangeValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "dateRangeValue", $$v)
      },
      expression: "form.dateRangeValue"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "choosetime"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('common.all'),
      "size": "small"
    },
    on: {
      "change": _vm.changeTime
    },
    model: {
      value: (_vm.form.choosetime),
      callback: function($$v) {
        _vm.$set(_vm.form, "choosetime", $$v)
      },
      expression: "form.choosetime"
    }
  }, _vm._l((_vm.choosetimes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [(!_vm.role.single) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.panel.shopName')))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "selectShopUid"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": _vm.$t('tradeMng.panel.tip1'),
      "size": "small",
      "loading": _vm.shopLoading
    },
    on: {
      "change": _vm.getOperators
    },
    model: {
      value: (_vm.form.selectShopUid),
      callback: function($$v) {
        _vm.$set(_vm.form, "selectShopUid", $$v)
      },
      expression: "form.selectShopUid"
    }
  }, _vm._l((_vm.shopData.list), function(shop) {
    return _c('el-option', {
      key: shop.uid,
      attrs: {
        "label": shop.shop_name,
        "value": shop.uid
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.role.isCashier) ? _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.panel.operator')))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "operaValue"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('tradeMng.table.all'),
      "size": "small",
      "disabled": _vm.form.selectShopUid === ''
    },
    model: {
      value: (_vm.form.operaValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "operaValue", $$v)
      },
      expression: "form.operaValue"
    }
  }, [_c('el-option', {
    attrs: {
      "label": _vm.$t('tradeMng.table.all'),
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": _vm.$t('tradeMng.table.main'),
      "value": "vl"
    }
  }), _vm._v(" "), _vm._l((_vm.operaList), function(label, value) {
    return _c('el-option', {
      key: value,
      attrs: {
        "label": label,
        "value": value
      }
    })
  })], 2)], 1)], 1) : _vm._e()]), _vm._v(" "), (_vm.typeList.length > 0) ? _c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.colWay')))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "checkAll1"
    }
  }, [_c('el-checkbox', {
    on: {
      "change": _vm.handleCheckAllChange1
    },
    model: {
      value: (_vm.form.checkAll1),
      callback: function($$v) {
        _vm.$set(_vm.form, "checkAll1", $$v)
      },
      expression: "form.checkAll1"
    }
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.panel.noLimit')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "type"
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedCitiesChange1
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper orderno_nowrap"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.panel.sNum')))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "orderno"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input__fix panel-select-input-220",
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('tradeMng.msg.m8'),
      "size": "small"
    },
    model: {
      value: (_vm.form.orderno),
      callback: function($$v) {
        _vm.$set(_vm.form, "orderno", $$v)
      },
      expression: "form.orderno"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.panel.chnlsn')))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "chnlsn"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input__fix panel-select-input-220",
    attrs: {
      "placeholder": _vm.$t('tradeMng.msg.m17'),
      "size": "small"
    },
    model: {
      value: (_vm.form.chnlsn),
      callback: function($$v) {
        _vm.$set(_vm.form, "chnlsn", $$v)
      },
      expression: "form.chnlsn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper orderno_nowrap"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.merchantOrder')))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "outtradeno"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input__fix panel-select-input-220",
    attrs: {
      "placeholder": _vm.$t('tradeMng.msg.m18'),
      "size": "small"
    },
    model: {
      value: (_vm.form.outtradeno),
      callback: function($$v) {
        _vm.$set(_vm.form, "outtradeno", $$v)
      },
      expression: "form.outtradeno"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isAdvancedSearchClick) ? _c('div', {
    staticClass: "panel-select__wrapper orderno_nowrap"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.panel.cardScheme')))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "cardscheme"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": _vm.$t('common.all')
    },
    model: {
      value: (_vm.form.cardscheme),
      callback: function($$v) {
        _vm.$set(_vm.form, "cardscheme", $$v)
      },
      expression: "form.cardscheme"
    }
  }, _vm._l((_vm.schemeList), function(scheme) {
    return _c('el-option', {
      key: scheme.value,
      attrs: {
        "label": scheme.name,
        "value": scheme.value
      }
    })
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn-group",
    class: {
      'advanced_group': _vm.isScreenSmall, 'advanced_group_large_style': _vm.isAdvancedSearchClick && _vm.isScreenBig, 'advanced_group_resize': _vm.isScreenSmall && _vm.isAdvancedSearchClick
    }
  }, [(_vm.isCardPayment) ? _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill advance",
    on: {
      "click": _vm.advancedSearch
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('tradeMng.panel.btn.advancedSearch')))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-down",
    class: {
      'advanced_arrow': _vm.isAdvancedSearchClick
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill",
    class: {
      'margin19': _vm.isScreenSmall && _vm.isCardPayment
    },
    on: {
      "click": _vm.search
    }
  }, [(_vm.loading) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v(_vm._s(_vm.$t('tradeMng.panel.btn.query')))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn transctl-btn",
    class: {
      'reset_margin': _vm.isScreenSmall && _vm.isCardPayment
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.panel.btn.reset')))])])]), _vm._v(" "), (_vm.isAdvancedSearchClick) ? _c('div', {
    staticClass: "panel-select-group advanced"
  }, [_c('div', {
    staticClass: "panel-select__wrapper orderno_nowrap"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.panel.lastevent')))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "cardlastevent"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": _vm.$t('common.all')
    },
    model: {
      value: (_vm.form.cardlastevent),
      callback: function($$v) {
        _vm.$set(_vm.form, "cardlastevent", $$v)
      },
      expression: "form.cardlastevent"
    }
  }, _vm._l((_vm.eventList), function(event) {
    return _c('el-option', {
      key: event.value,
      attrs: {
        "label": event.name,
        "value": event.value
      }
    })
  }), 1)], 1)], 1)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-btn-group__wrapper panel-body-btn-group flex-normal"
  }, [_c('div', {
    staticClass: "num_total"
  }, [_c('div', {
    staticClass: "num_wrapper toolShow4"
  }, [_c('p', {
    staticClass: "num-title cell toolShow4"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.succAmount')))]), _vm._v(" "), _c('p', {
    staticClass: "num-desc"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.transData.sucamt)) + " " + _vm._s(_vm.role.currency))])]), _vm._v(" "), _c('div', {
    staticClass: "num_wrapper toolShow5"
  }, [_c('p', {
    staticClass: "num-title cell toolShow5"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.succ')))]), _vm._v(" "), _c('p', {
    staticClass: "num-desc"
  }, [_vm._v(_vm._s(_vm.transData.sucnum || 0))])]), _vm._v(" "), _c('div', {
    staticClass: "num_wrapper toolShow6"
  }, [_c('p', {
    staticClass: "num-title cell toolShow6"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.refundMount')))]), _vm._v(" "), _c('p', {
    staticClass: "num-desc"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.transData.cancel_amt)) + " " + _vm._s(_vm.role.currency))])]), _vm._v(" "), _c('div', {
    staticClass: "num_wrapper toolShow7"
  }, [_c('p', {
    staticClass: "num-title cell toolShow7"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.refundNum')))]), _vm._v(" "), _c('p', {
    staticClass: "num-default"
  }, [_vm._v(_vm._s(_vm.transData.cancel_num || 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "a-wrapper"
  }, [_c('el-dropdown', [_c('div', {
    staticClass: "banner-btn"
  }, [_c('img', {
    attrs: {
      "src": require("./img/download.png"),
      "alt": "download"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "banner-btn__desc"
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.down')))])]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('a', {
    attrs: {
      "href": _vm.detailHref,
      "download": ""
    }
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.btn.downDetail')))])], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.separateHref,
      "download": ""
    }
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.btn.downTrade')))])], 1)])], 1)], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.transData.data,
      "row-class-name": "el-table__row_fix",
      "row-class-name": _vm.getStyle
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('tradeMng.table.shopName'),
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.username))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('tradeMng.table.operator'),
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.opuser || '-'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "busicd_info",
      "label": _vm.$t('tradeMng.table.tradeType'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sysdtm",
      "min-width": "160",
      "label": _vm.$t('tradeMng.table.tradeTime')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.sysdtm))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('tradeMng.table.tradeAmount'),
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "table-title"
        }, [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.txamt)))]), _vm._v(" "), (scope.row.busicd === '802101') ? _c('div', {
          staticClass: "table-content"
        }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.originAmount')) + " " + _vm._s(_vm._f("formatCurrency")(scope.row.order_amt)))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('tradeMng.table.currency'),
      "width": "85"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(_vm.shop.currency_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status_str",
      "label": _vm.$t('tradeMng.table.tradeState'),
      "width": "80"
    }
  }), _vm._v(" "), (_vm.isCardPayment) ? _c('el-table-column', {
    key: "1",
    attrs: {
      "prop": "cardlastevent",
      "label": _vm.$t('tradeMng.panel.lastevent'),
      "min-width": "140"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "140",
      "label": _vm.$t('tradeMng.table.sNum'),
      "label-class-name": "toolShow1"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.origssn ? scope.row.syssn + '(' + _vm.$t('tradeMng.detail.syssn2') + ':' + scope.row.origssn + ')' : scope.row.syssn))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "chnlsn",
      "label": _vm.$t('tradeMng.table.chnlsn'),
      "width": "150",
      "label-class-name": "toolShow2"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "out_trade_no",
      "label": _vm.$t('tradeMng.table.merchantOrder'),
      "width": "150",
      "label-class-name": "toolShow3"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "customer_id",
      "label": _vm.$t('tradeMng.table.customerId'),
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "src",
      "label": _vm.$t('tradeMng.table.src'),
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "note",
      "label": _vm.$t('tradeMng.table.remark'),
      "width": "85"
    }
  }), _vm._v(" "), (_vm.isCardPayment) ? [_c('el-table-column', {
    attrs: {
      "prop": "cardcd",
      "label": _vm.$t('tradeMng.table.cardNumber'),
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cardscheme",
      "label": _vm.$t('tradeMng.table.cardScheme'),
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cardtype",
      "label": _vm.$t('tradeMng.table.cardType'),
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cardarea",
      "label": _vm.$t('tradeMng.table.cardArea'),
      "min-width": "100"
    }
  })] : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": _vm.lang === 'en' ? 280 : 220,
      "label": _vm.$t('tradeMng.table.op'),
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.refund_visible) ? _c('el-button', {
          staticClass: "el-button__fix",
          attrs: {
            "type": "text",
            "size": "small",
            "disabled": _vm.showRefund(scope.row)
          },
          on: {
            "click": function($event) {
              return _vm.confirm(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.cancel')))]) : _vm._e(), _vm._v(" "), _c('el-button', {
          staticClass: "el-button__fix",
          attrs: {
            "type": "text",
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.detail(scope.row)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.detail')))]), _vm._v(" "), _c('a', {
          attrs: {
            "href": _vm.downUrl
          },
          on: {
            "click": function($event) {
              return _vm.downHref(scope.$index, $event)
            }
          }
        }, [_c('span', {
          attrs: {
            "id": "tr-download"
          }
        }, [_vm._v(_vm._s(_vm.$t('tradeMng.table.download')))])])]
      }
    }])
  })], 2)], 1), _vm._v(" "), (_vm.transData.num >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.transData.num,
      "current-page": _vm.currentPage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1) : _c('div', {
    staticClass: "table_placeholder"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.refundData.isNextDayRefund ? _vm.$t('tradeMng.dialog.d8') : _vm.$t('tradeMng.dialog.d2'),
      "visible": _vm.showConfirm,
      "custom-class": "mydialog",
      "top": "20%"
    },
    on: {
      "update:visible": function($event) {
        _vm.showConfirm = $event
      },
      "close": function($event) {
        return _vm.handleClose('formpwd')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('tradeMng.dialog.d1')))]), _vm._v(" "), _c('el-form', {
    ref: "formpwd",
    attrs: {
      "model": _vm.formpwd,
      "rules": _vm.pwdrules,
      "label-width": (_vm.lang === 'ja' || _vm.lang === 'en') ? '110px' : '80px',
      "autocomplete": "off"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('tradeMng.panel.sNum')
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.refundData.syssn))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "amount",
    attrs: {
      "prop": "amount",
      "label": _vm.$t('tradeMng.detail.amount2')
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.role.currency))]), _vm._v(" "), _c('el-input', {
    staticClass: "showAmount",
    attrs: {
      "name": "amount",
      "placeholder": _vm.$t('tradeMng.msg.m14') + ' ' + _vm.refundAmount,
      "type": "number"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.formpwd.amount),
      callback: function($$v) {
        _vm.$set(_vm.formpwd, "amount", $$v)
      },
      expression: "formpwd.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pwd",
      "label": _vm.$t('tradeMng.dialog.d5')
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('tradeMng.msg.m9'),
      "auto-complete": "new-password",
      "type": "password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnter($event)
      }
    },
    model: {
      value: (_vm.formpwd.pwd),
      callback: function($$v) {
        _vm.$set(_vm.formpwd, "pwd", $$v)
      },
      expression: "formpwd.pwd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.checkPwd
    }
  }, [(_vm.iconLoading) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v(_vm._s(_vm.$t('common.confirm')))])])])], 1), _vm._v(" "), _c('el-dialog', {
    class: [_vm.refundStates !== 3 ? (_vm.refundStates === 1 ? 'success' : 'wait') : 'fail'],
    attrs: {
      "title": _vm.refundStates !== 3 ? (_vm.refundStates === 1 ? _vm.$t('tradeMng.dialog.d3') : _vm.$t('tradeMng.dialog.d7')) : _vm.$t('tradeMng.dialog.d4'),
      "visible": _vm.showArefund,
      "custom-class": "mydialog refund",
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showArefund = $event
      }
    }
  }, [(_vm.refundStates !== 3) ? _c('div', [_c('el-form', {
    attrs: {
      "label-width": _vm.lang === 'en' ? '150px' : '90px'
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('tradeMng.detail.amount2')
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.role.currency))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v(_vm._s(_vm._f("formatCurrency")(_vm.refundInfo.txamt)))])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('tradeMng.table.tradeType')
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('tradeMng.dialog.d6')))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('tradeMng.detail.syssn3')
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.refundInfo.syssn))])])], 1)], 1) : _c('div', {
    staticClass: "refundfail"
  }, [_vm._v("\n      " + _vm._s(_vm.refundInfo.resperr) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "submit",
    on: {
      "click": function($event) {
        _vm.showArefund = false
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.confirm')))])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "success",
    attrs: {
      "title": _vm.$t('tradeMng.dialog.d9'),
      "visible": _vm.showSubmitRequest,
      "custom-class": "mydialog submit_request",
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showSubmitRequest = $event
      }
    }
  }, [_c('el-form', {
    staticClass: "content",
    attrs: {
      "label-width": _vm.lang === 'en' ? '150px' : '90px'
    }
  }, [_c('el-form-item', {
    staticClass: "refund_amount",
    attrs: {
      "label": _vm.$t('tradeMng.dialog.refundAmount')
    }
  }, [_c('div', [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.role.currency))]), _vm._v(" "), (_vm.formpwd.amount) ? _c('span', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v(_vm._s(_vm.refund_amount))]) : _vm._e()])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "approval_type",
    attrs: {
      "label": _vm.$t('tradeMng.dialog.approvalType')
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.refundData.busicd_info))])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-8ca688f0"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/transctl/transctl.vue
// module id = 928
// module chunks = 0